// extracted by mini-css-extract-plugin
export default {"container":"SortableTh_container__+U4Xn","content":"SortableTh_content__fx7LD","icon":"SortableTh_icon__9odpm","active":"SortableTh_active__97AH9","desc":"SortableTh_desc__X9yre"};